import { modules as modulesAPI } from 'api'
import Timeout from 'services/Timeout'

export default class Grafana {
  /**
   * Oauth authentication in grafana using nixi1
   * @param {string} urlParams params in url
   * @param {string} authToken authentication token on nixi1
   *
   * @returns {Promise<Boolean>}
   */
  static async oauthRedirect(urlParams, authToken) {
    if(!urlParams) return false

    try {
      const params = new URLSearchParams(urlParams)
      const redirectUri = params.get('redirect_uri')
      const state = params.get('state')
      const clientId = params.get('client_id')

      if(!redirectUri.includes('grafana') || !clientId || !state) return false

      const { data } = await modulesAPI.validateGrafanaAccess({ clientId })
      if(!data.isActive) return false

      const timeout = new Timeout(5)

      // Redirect
      window.location.replace(`${redirectUri}?code=${authToken}&state=${state}`)

      await timeout.synchronous(true)

      return true
    } catch(error) {

      return false
    }
  }

  /**
   * Open grafana url from the dashboard
   * @param {string} url
   * @param {string} companyId
   * @param {object} [options]
   * @param {'es'|'en'} [options.locale]
   */
  static async openTab(url, companyId, options = {}) {
    const  { locale = 'es' } = options

    const name = `grafanaTab_${companyId}`
    const rUrl = url.replace('<%=locale%>', locale !== 'en' ? 'es' : 'en')

    let grafanaTab = window.open(`${rUrl}?var-companyId=${companyId}`, name)
    if (grafanaTab) grafanaTab.focus()
    grafanaTab = null
  }
}